import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation.ts';
import { preloadUseExtensionList } from '@confluence/forge-ui/entry-points/preloadUseExtensionList.ts';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { fg } from '@confluence/feature-gating';

import { getGlobalAppsParams } from './getGlobalAppsParams.ts';

export const preloadGlobalApps = async () => {
	const { edition, accessStatus } = getPreloaderFnContext();

	const { webItemParams, forgeExtensionParams } = getGlobalAppsParams({
		edition,
		accessStatus,
	});

	const promises = [preloadWebItemLocation(webItemParams)];

	if (fg('confluence_nav_4_global_forge_extensions_preload')) {
		promises.push(preloadUseExtensionList(forgeExtensionParams));
	}

	return waitForAllReturnWhenError(promises);
};
